'use strict';

module.exports = function sortDesc() {
  return this.sort().reverse();
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/sortDesc.js
// module id = 1719
// module chunks = 2